import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    scoreCardWrap: {
        display: 'flex',
        overflow: 'auto',
        margin: theme.spacing(0, -1, 3),
        [theme.breakpoints.up('sm')]: {
            
        },
    },
    scoreCardBox: {
        margin: theme.spacing(1),
        width: `calc(20% - ${theme.spacing(2)}px)`,
        maxWidth: `calc(20% - ${theme.spacing(2)}px)`,
        flex: `calc(20% - ${theme.spacing(2)}px)`,
        minWidth: '100px',
    }
}));

